function getViewportElement() {
  return document.querySelector('meta[name=viewport]')
}

export function disableZoom() {
  const viewport = getViewportElement()
  if (viewport) {
    viewport.setAttribute(
      'content',
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'
    )
  }
}

export function enableZoom() {
  const viewport = getViewportElement()
  if (viewport) {
    viewport.setAttribute('content', 'width=device-width, initial-scale=1, viewport-fit=cover')
  }
}
